import { spaceCadet, ultraMarine } from '@cogneed/react-utils';
import { PushPinRounded, PushPinOutlined } from '@mui/icons-material';
import { Button, ButtonProps, styled } from '@mui/material';

interface PinButtonProps extends ButtonProps {
  pinned: boolean;
}

const PinButton = styled((props: Omit<PinButtonProps, 'children'>) => {
  const { pinned, ...other } = props;
  return (
    <Button {...other}>
      {pinned ? <PushPinRounded /> : <PushPinOutlined />}
    </Button>
  );
})(() => ({
  backgroundColor: ultraMarine[100],
  color: spaceCadet[800],
  minWidth: 'initial',
  padding: 4,
  minHeight: 'initial',
  height: 24,
  '& .MuiSvgIcon-root': {
    fontSize: 16,
  },
}));

export default PinButton;
